import { useEffect } from "react";
import { UserListScreen } from '@nebulr-group/nblocks-react/lib/screens/user/UserList.screen';
import { Navigate, Route, Routes } from "react-router-dom";
import { Workspace } from "src/components/user-management/workspace";
import { Profile } from "src/components/user-management/profile";
import { HeadingComponent } from "@nebulr-group/nblocks-react/lib/components/shared/HeadingComponent";

function UserManagement() {

  const name = "User management";

  useEffect(() => {
    document.title = name ? name : "";
  }, [name]);

  return (
    <>
      {/* <Sidebar /> */}
      <Routes>
        <Route path="profile" element={<Wrapper title="Profile"><Profile/></Wrapper>} />
        <Route path="workspace" element={<Wrapper title="Workspace"><Workspace/></Wrapper>} />
        <Route path="users" element={<UserListScreen/>} />
        <Route path="*" element={<Navigate to={"profile"} />} />
      </Routes>
    </>
  );
}

const Wrapper = ({title, children}: {title: string, children: React.ReactElement}) => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex justify-between items-center py-5 mx-6">
        <HeadingComponent type={"h1"} size={"3xl"} className={"inline-block"}>
          {title}
        </HeadingComponent>
      </div>
      <div className="grow flex flex-col justify-between">
        {children}
      </div>
    </div>
  )
}

export default UserManagement;
